<template>
    <div class="main">
        <el-dialog
            title="签到表"
            :visible.sync="openData.state"
            width="70%"
            class="dialog_container printing"
            @close="dialogClose"
        >
            <div class="dayincss" ref="print">
                <!-- <h2>项目签到表</h2> -->
                <div class="twohang">
                    <span>活动名称:</span>
                    <span>活动时间:</span>
                    <div style="width: 50px"></div>
                    <span>年</span>
                    <div style="width: 50px"></div>
                    <span>月</span>
                    <div style="width: 50px"></div>
                    <span>日</span>
                </div>
                <el-table
                    :data="tableData"
                    :header-cell-style="{ background: '#f8fafa' }"
                    border
                    align="center"
                    current-row-key
                    highlight-current-row
                >
                    <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="60"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="name"
                        label="姓名"
                        width="90"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        label="手机号"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="workHour"
                        label="工时"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="signupDate"
                        label="签到时间"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="signOutDate"
                        label="签退时间"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="参与情况"
                        width="270px"
                    >
                        <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.participation">
                                <el-radio label="0" disabled>参加</el-radio>
                                <el-radio label="1" disabled>未到</el-radio>
                                <el-radio label="2" disabled>中途离场</el-radio>
                            </el-radio-group>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="mt25"
                    align="center"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :current-page.sync="pageNo"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    @size-change="handletableDataSize"
                    @current-change="handleTableDataChange"
                ></el-pagination>
            </div>

            <div class="footer">
                <el-button type="primary" @click="save">打 印</el-button>
                <el-button @click="dialogClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            saveLoading: false,
            searchLoading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            tableData: [],
        };
    },
    created() {
        this.getList();
    },

    methods: {
        // 获取表格数据
        getList() {
            let params = {
                serverActiveId: this.openData.id,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
            };
            this.$http
                .request({
                    url: "/ypt/orgWork/communityActivity/info/signInForm",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = [];
                            this.total = 0;
                            return;
                        }
                        this.tableData = res.content.list;
                        this.total = res.content.count;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        // 页面大小
        handletableDataSize(val) {
            this.pageSize = val;
            this.getList();
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageNo = val;
            this.getList();
        },

        // 保存信息
        save() {
            this.$print(this.$refs.print);
        },
        // 关闭人员信息
        dialogClose() {
            this.$emit("canclePerson", false);
        },
    },
};
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.dayincss {
    margin: 25px 0;
    h2 {
        text-align: center;
        font-weight: 800;
        margin-bottom: 20px;
    }
    .twohang {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        span:first-child {
            box-sizing: border-box;
            flex: 1;
        }
    }
}
.mt25 {
    margin-top: 25px;
}
</style>